// Volta para a pausa de sistema 25 (VOC-499). Puro, dependências injetadas.
// O dialplan agent-pause recusa em silêncio (busy) enquanto houver outro canal do ramal,
// inclusive o do *12 tocando agent-unpaused. Então: espera o ramal livrar, envia, confirma
// pelo SIP Agent PAUSED e reenvia se não vier.
export const SYSTEM_PAUSE_REPAUSE_SETTLE_MS = 1000
export const SYSTEM_PAUSE_REPAUSE_CONFIRM_MS = 4000
export const SYSTEM_PAUSE_REPAUSE_MAX_ATTEMPTS = 3
export const SYSTEM_PAUSE_REPAUSE_ERROR = 'Não foi possível voltar para a pausa. Pause manualmente.'

export const createSystemPauseRepause = ({
  sendPause, isBusy, notify,
  setTimeout: setTimer = globalThis.setTimeout,
  clearTimeout: clearTimer = globalThis.clearTimeout,
  warn = (...args) => console.warn(...args),
  settleMs = SYSTEM_PAUSE_REPAUSE_SETTLE_MS,
  confirmMs = SYSTEM_PAUSE_REPAUSE_CONFIRM_MS,
  maxAttempts = SYSTEM_PAUSE_REPAUSE_MAX_ATTEMPTS
}) => {
  let pending = null

  const isPending = () => pending !== null

  const finish = () => {
    if (pending?.timer !== null && pending?.timer !== undefined) clearTimer(pending.timer)
    pending = null
  }

  const schedule = (fn, ms) => { pending.timer = setTimer(fn, ms) }

  // Espera o ramal livrar; o intervalo cobre o canal ainda no h da central.
  const waitIdle = () => {
    if (!pending) return
    if (isBusy()) return schedule(waitIdle, settleMs)
    attempt()
  }

  const attempt = () => {
    if (!pending) return
    pending.attempts++
    sendPause(pending.reasonId)
    schedule(onConfirmTimeout, confirmMs)
  }

  const onConfirmTimeout = () => {
    if (!pending) return
    if (pending.attempts < maxAttempts) return schedule(waitIdle, settleMs)
    finish()
    warn('[systemPauseRepause] volta para a pausa não confirmada; desistindo')
    notify(SYSTEM_PAUSE_REPAUSE_ERROR)
  }

  const request = (reasonId) => {
    if (pending) return false
    pending = { reasonId, attempts: 0, timer: null }
    schedule(waitIdle, settleMs)
    return true
  }

  // Chamado a cada SIP Agent recebido.
  const onAgentStatus = (status) => {
    if (pending && status === 'PAUSED') finish()
  }

  return { request, onAgentStatus, isPending, cancel: finish }
}
